import styled from "styled-components";
import LinkTotalTitle from "../../atoms/link/LinkTotalTitle";
import AllDeviceConnectionTable from "../../molecules/all/AllDeviceConnectionTable";
import { COLORS } from "../../../constants/colors";
import { AllDeviceProjectsConnectionCardProps } from "../../../constants/types";

const AllDeviceProjectsConnectionCard = (
  props: AllDeviceProjectsConnectionCardProps
) => {
  return (
    <Container>
      <LinkTotalTitle
        total={props.data.total.total}
        disconnected={props.data.total.disConnected}
      />
      <AllDeviceConnectionTable data={props.data.list} />
    </Container>
  );
};

export default AllDeviceProjectsConnectionCard;

const Container = styled.div`
  width: 30%;
  height: 100%;

  border: 0.2vw solid ${COLORS.lightGray};

  box-sizing: border-box;
  padding: 1%;
  .text {
    font-size: 1.2vw;
  }
`;
